__turbopack_context__.v({
  "Button": "TU2zmq_Button",
  "ChildrenTitle": "TU2zmq_ChildrenTitle",
  "ChildrenWrapper": "TU2zmq_ChildrenWrapper",
  "Description": "TU2zmq_Description",
  "Header": "TU2zmq_Header",
  "Icon": "TU2zmq_Icon",
  "Root": "TU2zmq_Root",
  "Root--BlackHeaderBackground": "TU2zmq_Root--BlackHeaderBackground",
  "Root--ChildrenTitle": "TU2zmq_Root--ChildrenTitle",
  "Root--Expanded": "TU2zmq_Root--Expanded",
  "Root--Large": "TU2zmq_Root--Large",
  "Root--Small": "TU2zmq_Root--Small",
  "TextWrapper": "TU2zmq_TextWrapper",
  "skeleton-loading": "TU2zmq_skeleton-loading",
});
